import {
  ManufacturingComboboxPicker,
  type ComboboxOption,
} from "@/components/manufacturing/ManufacturingComboboxPicker";
import { ghostBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import type { MfgLaborRateItem } from "@/lib/manufacturing/laborBillingTypes";
import type { LaborPaysBy } from "@/lib/manufacturing/laborPayQuantity";
import { laborPaysByShort } from "@/lib/manufacturing/laborPayQuantity";
import type { MfgRecipeSummary } from "@/lib/manufacturing/types";
import { ManufacturingLaborPaysBySelect } from "./ManufacturingLaborPaysBySelect";

function money(n: number) {
  return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
}

export function ManufacturingLaborCompanyRateUnmatchedRow({
  item,
  readOnly,
  listBusy,
  rowBusy,
  selected,
  paysBy,
  options,
  onToggle,
  onPaysBy,
  onSavePaysBy,
  onLink,
  onCreateUnconfirmed,
}: {
  item: MfgLaborRateItem;
  readOnly: boolean;
  listBusy: boolean;
  rowBusy: boolean;
  selected: boolean;
  paysBy: LaborPaysBy | "";
  options: ComboboxOption<MfgRecipeSummary>[];
  onToggle: () => void;
  onPaysBy: (pays_by: LaborPaysBy | "") => void;
  onSavePaysBy: () => void;
  onLink: (recipe: MfgRecipeSummary) => void;
  onCreateUnconfirmed: () => void;
}) {
  const disabled = listBusy || rowBusy;
  return (
    <li className="rounded-xl border border-amber-200 bg-amber-50/70 p-3 dark:border-amber-900 dark:bg-amber-950/30">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <label className="flex min-w-0 items-center gap-2 font-medium text-gray-900 dark:text-zinc-100">
          {readOnly ? null : (
            <input
              type="checkbox"
              className="shrink-0"
              checked={selected}
              disabled={listBusy}
              onChange={onToggle}
            />
          )}
          <span>{item.label}</span>
        </label>
        <div className="text-xs text-gray-600 dark:text-zinc-400">
          <code>{item.item_code}</code> · {money(item.flat_rate_usd)} / {laborPaysByShort(item.pays_by)}
        </div>
      </div>
      {readOnly ? null : (
        <div className="mt-2 flex flex-wrap items-end gap-2">
          <label className="block min-w-[12rem] text-xs text-gray-600 dark:text-zinc-400">
            Pays by
            <ManufacturingLaborPaysBySelect value={paysBy} disabled={disabled} onChange={onPaysBy} />
          </label>
          {item.recipe_id ? (
            <button
              type="button"
              className={ghostBtnClass}
              disabled={disabled || !paysBy}
              onClick={onSavePaysBy}
            >
              {rowBusy ? "Working…" : "Save Pays by"}
            </button>
          ) : (
            <>
              <div className="min-w-[14rem] flex-1">
                <ManufacturingComboboxPicker<MfgRecipeSummary>
                  value=""
                  options={options}
                  placeholder="Match a Models SKU…"
                  initialQuery={item.label}
                  disabled={disabled || !paysBy}
                  onPick={(opt) => onLink(opt.data)}
                />
              </div>
              <button
                type="button"
                className={ghostBtnClass}
                disabled={disabled || !paysBy}
                onClick={onCreateUnconfirmed}
              >
                {rowBusy ? "Working…" : "Create unconfirmed model"}
              </button>
            </>
          )}
        </div>
      )}
    </li>
  );
}
